
import { Component, Vue, Prop } from 'vue-property-decorator';
import { HeaderInfo } from './types';

@Component({})
export default class Header extends Vue {
  /** 头部信息 */
  @Prop() headerInfo!: HeaderInfo;
}
